const events = require('./events');
const { memory } = require('@flowio/storage');

function getFunc(name) {
  switch (name) {
  case 'on':
    return events.on;
  case 'set':
    return memory.set;
  case 'triggerEvent':
    return events.trigger;
  default:
    return undefined;
  }
}

function getQueue() {
  if (window.Flow) {
    if (!window.Flow.q) {
      window.Flow.q = [];
    }

    return window.Flow.q;
  }

  return [];
}

function canProcess(qItem) {
  return !!getFunc(qItem[0]);
}

function hasItems(queue) {
  let found = false;
  queue.forEach((qItem) => {
    const item = Array.prototype.slice.call(qItem);
    if (canProcess(item)) {
      found = true;
    }
  });
  return found;
}

function processItem(qItem) {
  const func = getFunc(qItem[0]);
  func.apply(this, qItem.slice(1));
}

function dequeue() {
  const queue = getQueue();
  if (queue && queue.length) {
    const qItem = queue.shift();
    const item = Array.prototype.slice.call(qItem);

    if (canProcess(item)) {
      processItem(item);
    } else {
      queue.push(qItem);
    }
  }
}

function enqueue(args) {
  getQueue().push(args);
}

function processQueue() {
  if (window.Flow && window.Flow.q) {
    while (hasItems(window.Flow.q)) {
      dequeue();
    }
  }
}

function set(...args) {
  enqueue(args);
  processQueue();
}

module.exports = {
  processQueue,
  set,
};



// WEBPACK FOOTER //
// ./static/js/v0/queue.js